/**
 * @generated SignedSource<<c5e383af4bd156c317c652154cfc8fe9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsTravelDocumentEditPageQuery$variables = {
  id: string;
};
export type SettingsTravelDocumentEditPageQuery$data = {
  readonly travelDocument: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "TravelDocumentEditForm_document">;
  } | null;
};
export type SettingsTravelDocumentEditPageQuery = {
  response: SettingsTravelDocumentEditPageQuery$data;
  variables: SettingsTravelDocumentEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsTravelDocumentEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TravelDocument",
        "kind": "LinkedField",
        "name": "travelDocument",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TravelDocumentEditForm_document"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsTravelDocumentEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TravelDocument",
        "kind": "LinkedField",
        "name": "travelDocument",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3fb6cd133bace6360e0c03df5468a13",
    "id": null,
    "metadata": {},
    "name": "SettingsTravelDocumentEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsTravelDocumentEditPageQuery(\n  $id: ID!\n) {\n  travelDocument(id: $id) {\n    name\n    ...EntitySidebar_entity\n    ...TravelDocumentEditForm_document\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment TravelDocumentEditForm_document on TravelDocument {\n  id\n  name\n}\n"
  }
};
})();

(node as any).hash = "7aa575a6b145cf8e40553a76d76b5bdb";

export default node;
